const BaseURL = {
  uat: "https://apigatewayuat.oppein.com/",
  ver: "https://apigatewayver.oppein.com/",
  pro: "https://apigateway.oppein.com/"
};
export { BaseURL };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/axios/baseUrl.js